"use client";
import React from "react";
import { useDialog } from '@/hooks/useDialog';
import { useAuth } from "@/contexts/AuthContext";
import acuerdoApi from "@/api/Acuerdo";

import Breadcrumb from "@/components/Breadcrumbs/Breadcrumb";
import Form from "./components/form";

const AcuerdoResponsabilidad = () => {
  const { user, loading: userLoading } = useAuth();
  const { show } = useDialog();

  return (
    <>
      <Breadcrumb pageName="Acuerdo de Responsabilidad y Uso de Medios Electrónicos" />
      <div className="grid grid-cols-1 gap-4">
        {userLoading ? (
          <div className="flex justify-center items-center">
            <span className="loading loading-spinner"></span>
          </div>
        ) : (
          <Form api={acuerdoApi} show={show} user={user} userLoading={userLoading}></Form>
        )}
      </div>
    </>
  );
};

export default AcuerdoResponsabilidad;